// extracted by mini-css-extract-plugin
export var main = "Page-module--main--2ZSDD";
export var fixed = "Page-module--fixed--2eGyc";
export var free = "Page-module--free--3l12v";